<template>
  <!-- 根据路由渲染不同页面 -->
  <router-view/>
</template>
<script>
export default { name: 'App' };
</script>
<style>
/* 全局可补充 */
</style>